export default {
  large: {},
  short: {},
  contentModule: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
  },
  contentModuleRow: {
    display: 'flex',
  },
  contentModuleCell: {
    display: 'table-cell',
    width: '50%',
    '&$short': {
      width: '35%'
    },
    '&$large': {
      width: '65%'
    },
  },
  contentModuleCellTitle: {
    font: "500 15px 'Roboto', sans-serif",
  },
  contentModuleCellPrice: {
    font: "500 15px 'Roboto', sans-serif",
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: "left"
    }
  },
  contentModuleCellRoom: {
    font: "300 15px 'Roboto', sans-serif",
    color: '#666666',
  },
  contentModuleCellRate: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#666666',
    marginLeft: '24px',
  },
  contentModuleCellRateName: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#666666',
    marginLeft: '24px',
  },
  contentModuleCellRateDescription: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#666666',
    marginLeft: '24px',
  },
  priceNumbers:{
    font: "300 13px 'Roboto', sans-serif",
    color: '#666',
  },
  roomContainer: {
    paddingLeft: '24px',
    textIndent: '-24px',
  }
};
